// import io from 'socket.io-client';
// import $ from './assets/js/jquery.min.js'
import './assets/js/app.js'
// import './assets/js/slick.min.js'
import './assets/css/main.css'
// import './assets/css/slick.css'
// import mainstyle1 from './assets/css/fontawesome/all.css'
import { createApp } from 'vue'
// import Vuex from 'vuex'
import { createStore } from 'vuex'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import VueGtag from "vue-gtag";

// Vue.config.devtools=true
// Vue.config.productionTip = true

/*Vue.use(VueGtag, {
  config: { id: "G-CEC80G3PJN"} 
});
*/


/*
setting_language: "vn"
setting_noti: true
setting_sound: true
st_token: "90463279-1a74-4c9c-b9fd-3361fbe3ab35"
*/
const store = createStore({
	state: {
		token: '',
		user_info: [],
		hasToken: false,
		notify:[],
		lang: '',
		show_rating: false,
		page: [],
		hasFocus: false,
		st_token: '',
		show_launcher: 0,
		first_component: '',
		setting_language: "vn",
		setting_sound: true,
		setting_noti: true
	},
	mutations: {
		set_lang (state, lang) {
			state.lang = lang;
			// Vue.$i18n.locale = lang;
		},
		set_lang_key (state, lang) {
			state.lang = lang;
			// Vue.$i18n.locale = lang;
		},
		show_rating (state, show_rating) {
			state.show_rating = show_rating;
		},
		set_token (state, token) {
			state.st_token = token;
			top.postMessage({st_token: token}, document.referrer);
		},
		set_page (state, page) {
			state.page = page;
		},
		set_hasFocus (state, hasFocus) {
			state.hasFocus = hasFocus;
		},
		set_show_launcher (state, show_launcher) {
			state.show_launcher = show_launcher;
		},
		set_first_component (state, first_component) {
			state.first_component = first_component;
		},

		/*loggedin (state, data) {
			state.token = data.token;
			state.user_info = data;
			state.hasToken = true;


		},
		logout (state) {
			state.token = '';
			state.user_info = [];
			state.hasToken = false;
			localStorage.setItem('user', {});
		},
		LOADING(state, payload) {
			state.loading = payload;
		},
		BREADCRUMB_TEXT(state, payload) {
			state.breadcrumb_text = payload;
		},
		DISMISS_NOTIFY(state, payload) {
			for (var i = 0; i < state.notify.length; i++)
				if (state.notify[i].index === payload) {
					state.notify.splice(i, 1);
					break;
				}

			},
		ADD_NOTIFY(state, payload) {
			state.notify.unshift(payload);
		},

		ADD_MESSAGES(state, payload) {
			state.messages = payload;
		},
		ADD_NOTIFICATIONS(state, payload) {
			state.notifications = payload;
		},*/
	},
	actions: {
		loading(context, payload){
			context.commit("LOADING", payload)
		},

	}
});  

// Vue.use(VueI18n)
/*const messages = {
  vn: vnMessage,
  en: enMessage,
}*/

const messages = livechat.languages;
const i18n = createI18n({
  locale: store.state.lang, // set locale
  messages,
  
})


/*new Vue({
	// router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
*/

const app = createApp(App)
// Vue.use(store)
app.use(i18n)

app.use(VueGtag,{
  config: { id: "G-CEC80G3PJN" }
})
app.use(store)
app.use(i18n)
/*console.log('VueGtag G-CEC80G3PJN');
// 5. Mount
app.mount('#app')*/
app.mount('#app')